import { render } from "./trust_reports.html?vue&type=template&id=6506b9ce&external"
import script from "./trust_reports.js?vue&type=script&lang=js&external"
export * from "./trust_reports.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__